var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-card"},[_c('img',{staticClass:"image",attrs:{"src":require(`@/assets/img/payment/${_vm.image}.png`),"alt":_vm.title}}),_c('h3',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"instruction"},[_vm._v(_vm._s(_vm.instruction))])])
}
var staticRenderFns = []

export { render, staticRenderFns }